
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/degree/[degreeSlug]",
      function () {
        return require("private-next-pages/degree/[degreeSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/degree/[degreeSlug]"])
      });
    }
  